import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from "../../base.component";
import {FilterUtil} from "../../../util/filter.util";
import {ListResponse} from "../../../network/service/list.response";
import {SnackBarUtil} from "../../../util/snack.bar.util";
import {VerifyOptions} from "../../dialog/verify/options/verify.options";
import {VerifyComponent} from "../../dialog/verify/verify.component";
import {DataResponse} from "../../../network/service/data.response";
import {RequestType} from '../../../enums/request.type';

@Component({
  selector: 'app-delivery-methods',
  standalone: false,
  templateUrl: './delivery-methods.component.html',
  styleUrls: ['./delivery-methods.component.scss']
})
export class DeliveryMethodsComponent extends BaseComponent implements OnInit {
  deliveryMethods: any[] = [];
  selectedDeliveryMethod?: any;
  isLoadingDeliveryMethods = false;
  editingDeliveryMethod: any = {};
  isEditing = false;
  isSubmitting = false;
  availablePaymentMethods: any[] = [];
  selectedPaymentMethods: any[] = [];
  selectedPaymentMethodIds: any[] = [];
  typeOptions = [
    {
      Value: 'INSIDE_DELIVER',
      Title: 'تحویل حضوری'
    },
    {
      Value: 'OUTSIDE_DELIVER',
      Title: 'بیرون بر'
    },
    {
      Value: 'INSIDE',
      Title: 'حضوری'
    }
  ];
  selectedType?: any;
  branchIds: any = [];
  selectedBranches: any = [];
  allFilters = FilterUtil.DeliveryMethodsFilters;
  filters: any = {};

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    this.isLoadingDeliveryMethods = true;
    this.serviceApi.getDeliveryMethods(undefined, undefined, 'DeliveryMethodsAttributes,DeliveryMethodsAttributes.Attribute,DeliveryMethodsAttributes.Attribute.AttributeType,DeliveryMethodPaymentMethods,DeliveryMethodPaymentMethods.PaymentMethod,DeliveryMethodBranches,DeliveryMethodBranches.Branch', undefined, {
      Filter: this.filters,
    }).subscribe((res: ListResponse<any>) => {
      this.isLoadingDeliveryMethods = false;
      if (res.success) {
        this.deliveryMethods = res.data || [];
        if (this.deliveryMethods && this.deliveryMethods.length > 0) {
          this.selectedDeliveryMethod = this.deliveryMethods[0];
          this.loadDeliveryMethodDetails();
        } else {
          this.selectedDeliveryMethod = undefined;
        }
        this.loadAvailablePaymentMethods();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  loadAvailablePaymentMethods() {
    this.serviceApi.getPaymentMethods(undefined, undefined, '', RequestType.ALL, undefined, {
      Filter: {}
    }).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.availablePaymentMethods = res.data || [];
      }
    });
  }

  onFiltersChanged(filters: any) {
    this.filters = filters;
    this.loadOnline();
  }

  onDeliveryMethodClick(deliveryMethod: any) {
    this.selectedDeliveryMethod = deliveryMethod;
    this.loadDeliveryMethodDetails();
  }

  loadDeliveryMethodDetails() {
    if (this.selectedDeliveryMethod) {
      this.editingDeliveryMethod = {...this.selectedDeliveryMethod};
      this.isEditing = true;
      this.loadFormData();
    } else {
      this.resetForm();
    }
  }

  loadFormData() {
    if (this.editingDeliveryMethod.Type) {
      this.selectedType = this.typeOptions.find(t => t.Value === this.editingDeliveryMethod.Type);
    } else {
      this.selectedType = undefined;
    }
    this.selectedBranches = this.editingDeliveryMethod.DeliveryMethodBranches.map((deliveryMethodBranch: any) => {
      return deliveryMethodBranch.Branch;
    });
    this.branchIds = this.editingDeliveryMethod.BranchIds;
    if (this.editingDeliveryMethod.DeliveryMethodPaymentMethods) {
      this.selectedPaymentMethods = this.editingDeliveryMethod.DeliveryMethodPaymentMethods.map((dmPayment: any) => {
        return dmPayment.PaymentMethod;
      });
      this.selectedPaymentMethodIds = this.selectedPaymentMethods.map((pm: any) => pm.PaymentMethodId);
    } else {
      this.selectedPaymentMethods = [];
      this.selectedPaymentMethodIds = [];
    }
  }

  onCreateDeliveryMethodClicked() {
    this.selectedDeliveryMethod = null;
    this.resetForm();
    this.isEditing = false;
    setTimeout(() => {
      this.editingDeliveryMethod.Latitude = 35.699737;
      this.editingDeliveryMethod.Longitude = 51.338061;
    }, 100);
  }

  onUpdateDeliveryMethodClicked(deliveryMethod: any) {
    this.selectedDeliveryMethod = deliveryMethod;
    this.loadDeliveryMethodDetails();
  }

  onDeleteDeliveryMethodClicked(deliveryMethod: any) {
    let verifyOptions = new VerifyOptions();
    verifyOptions.message = 'آیا از حذف روش ارسال مطمئن هستید؟';
    let verifyComponent = this.matDialog.open(VerifyComponent);
    verifyOptions.onNoClicked = () => {
      verifyComponent.close();
    };
    verifyOptions.onYesClicked = () => {
      this.serviceApi.deleteDeliveryMethods(deliveryMethod.DeliveryMethodId).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          verifyComponent.close();
          this.loadOnline();
          if (this.selectedDeliveryMethod?.DeliveryMethodId === deliveryMethod.DeliveryMethodId) {
            this.selectedDeliveryMethod = undefined;
            this.resetForm();
          }
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    };
    verifyComponent.componentInstance.verifyOptions = verifyOptions;
  }

  onTypeSelect(type?: any) {
    if (type) {
      this.editingDeliveryMethod.Type = type.Value;
      this.selectedType = type;
    }
  }

  onPaymentMethodsChanged(selectedIds: any[]) {
    this.selectedPaymentMethodIds = selectedIds;
    this.selectedPaymentMethods = this.availablePaymentMethods.filter(pm =>
      selectedIds.includes(pm.PaymentMethodId)
    );
  }

  onSubmitDeliveryMethod() {
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    let deliveryMethodData: any = {
      Title: this.editingDeliveryMethod.Title,
      Description: this.editingDeliveryMethod.Description,
      Price: this.editingDeliveryMethod.Price,
      Type: this.editingDeliveryMethod.Type,
      IsActive: this.editingDeliveryMethod.IsActive ?? true,
      Radius: this.editingDeliveryMethod.Radius,
      Latitude: this.editingDeliveryMethod.Latitude,
      Longitude: this.editingDeliveryMethod.Longitude,
      BranchIds: this.branchIds,
      PaymentMethodIds: this.selectedPaymentMethodIds
    };
    const apiCall = this.isEditing && this.editingDeliveryMethod.DeliveryMethodId
      ? this.serviceApi.updateDeliveryMethods(this.editingDeliveryMethod.DeliveryMethodId, deliveryMethodData)
      : this.serviceApi.createDeliveryMethods(deliveryMethodData);
    apiCall.subscribe((res: DataResponse<any>) => {
      this.isSubmitting = false;
      if (res.success) {
        this.loadOnline();
        if (this.isEditing && this.editingDeliveryMethod.DeliveryMethodId) {
          this.selectedDeliveryMethod = {...this.editingDeliveryMethod, ...deliveryMethodData};
        } else {
          this.selectedDeliveryMethod = res.data;
        }
        this.loadDeliveryMethodDetails();
        SnackBarUtil.makeMessage(this, 'عملیات با موفقیت انجام شد', true);
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  onCancelEdit() {
    if (this.selectedDeliveryMethod) {
      this.loadDeliveryMethodDetails();
    } else {
      this.resetForm();
    }
  }

  resetForm() {
    this.editingDeliveryMethod = {
      Title: '',
      Description: '',
      Price: 0,
      Type: '',
      IsActive: true,
      Radius: 1000,
      Latitude: 35.699737,
      Longitude: 51.338061
    };
    this.selectedType = undefined;
    this.selectedPaymentMethods = [];
    this.selectedPaymentMethodIds = [];
    this.isEditing = false;
  }

  getSelectedDeliveryMethodTitle(): string {
    if (this.selectedDeliveryMethod) {
      return this.selectedDeliveryMethod.Title || '';
    }
    return 'انتخاب روش ارسال';
  }

  getDeliveryMethodTypeTitle(type: string): string {
    const typeMap: { [key: string]: string } = {
      'INSIDE_DELIVER': 'تحویل حضوری',
      'OUTSIDE_DELIVER': 'بیرون بر',
      'INSIDE': 'حضوری'
    };
    return typeMap[type] || type;
  }
}
